import {AfterContentInit, Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RequestService} from '../../core/services/request/request.service';
import {CatalogDataModel} from '../../core/services/catalog-data/catalog-data.model';

@Component({
  selector: 'sb-survey-page',
  templateUrl: './survey-page.component.html',
  styleUrls: ['./survey-page.component.scss']
})
export class SurveyPageComponent implements OnInit {

  item: CatalogDataModel = null;
  nluModel: any = null;

  catalogID: string = null;
  responseID: string = null;

  submitted: boolean = false;

  constructor(private router: Router,
              private requestService: RequestService,
              private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.catalogID = params.get("catalogID");
      this.responseID = params.get("responseID");
      this.getCatalogueItem();
    });
  }

  async getCatalogueItem () {
    const response: any = await this.requestService.createRequest()
      .controller("servicely.core.Portal")
      .method("getCatalogItemByID")
      .data({ id: this.catalogID })
      .execute();

    if (response["data"] == null) {
      alert("Error: No data was not returned from the catalog item: " + this.catalogID);
    } else {
      this.item = JSON.parse(response.data);
    }
  }

  onSubmit (event: string) {
    // this.success(event);
    this.submitted = true;
  }

  navigate () {
    window.location.href = "/";
  }
}
